import React from 'react'

import { ProductOption, ProductOptionFilter } from 'src/apollo/onlineOrdering'

import { FilterOptionRows } from './FilterOptionRows'
import { FilterVariant, filterName } from '../filterUtils'

export type OptionFilterProps = {
  option: ProductOption
  variant: FilterVariant
  hasEntered: boolean
  selectedProductOptions: ProductOptionFilter[]
  handleProductOptionToggle: (optionName: string, value: string) => void
}

export const OptionFilter = ({
  option,
  variant,
  hasEntered,
  selectedProductOptions,
  handleProductOptionToggle
}: OptionFilterProps) => {
  const selectedOption = selectedProductOptions.find(
    (o) => o.name === option.name
  )
  return (
    <FilterOptionRows
      sectionName={option.name}
      name={filterName(variant, option.name)}
      hasEntered={hasEntered}
      values={option.values.map((value) => ({ name: value.name }))}
      selectedValues={new Set(selectedOption?.values ?? [])}
      onToggle={(valueName) =>
        handleProductOptionToggle(option.name, valueName)
      }
    />
  )
}
